import api from './api';

export const getUserProjects = async (userTypeId) => {
    try {
        const response = await api.get(`/UserProjects?userTypeId=${userTypeId}`);
        return response?.data;
    } catch (error) {
        throw error;
    }
};
export const getConstantProjects = async () => {
    try {
        const response = await api.get(`/AvailabilityTypes`);
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const addNewTimeSheet = async (formData, userTypeId) => {
    try {
        const response = await api.post(`/Timesheets?userTypeId=${userTypeId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const updateTimesheet = async (formData, userTypeId) => {
    try {
        const response = await api.put(`/Timesheets?userTypeId=${userTypeId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response?.data;
    } catch (error) {
        throw error;
    }
};
